import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import bgTitle from 'assets/images/bg_title.png';
import bgCount from 'assets/images/bg_count.png';

const categoryTabs = [
  'Đội vô địch',
  'Vua phá lưới',
  'Đội nhận thẻ đỏ đầu tiên',
  // 'Đội bị loại đầu tiên',
  // 'Đội đầu tiên vào vòng 16',
  // 'Đội đầu tiên vào vòng 32',
  'Cầu thủ xuất sắc nhất',
  'Đội Châu Á Vào Sâu Nhất'
];

const ruleContentByTab = {
  'Đội vô địch': {
    deadline: '11/06/2026 23:59:59 (GMT+7)',
    main: [
      'Nội dung dự đoán: Dự đoán đội tuyển giành chức vô địch World Cup 2026.',
      'Lựa chọn dự đoán: Hệ thống hiển thị toàn bộ các đội tuyển chính thức tham dự World Cup, hội viên chỉ được chọn duy nhất 1 đội tuyển.'
    ],
    conditions: [
      'Mỗi tài khoản chỉ có thể tham gia 01 lần.',
      'Có thể điều chỉnh lựa chọn trước thời gian kết thúc, nếu điều chỉnh nhiều lần hệ thống sẽ lấy lần dự đoán cuối cùng làm chuẩn.',
      'Thời gian kết thúc: 11/06/2026 23:59:59 (GMT +7).',
      'Quy tắc xác định: Lấy đội chiến thắng trận chung kết World Cup 2026 làm chuẩn, bao gồm cả hiệp phụ và loạt sút luân lưu.',
      'Quy tắc nhận code thưởng: Dự đoán đúng sẽ nhận được code từ 28 - 28,888 điểm'
    ],
    rewards: [
      'Thời gian phát thưởng 20/07/2026',
      'Dự đoán đúng sẽ nhận được code từ 28 - 28,888 điểm.'
    ]
  },
  'Vua phá lưới': {
    deadline: '11/06/2026 23:59:59 (GMT+7)',
    main: [
      'Nội dung dự đoán: Dự đoán cầu thủ ghi nhiều bàn thắng nhất World Cup 2026',
      'Lựa chọn dự đoán: Hệ thống hiển thị toàn bộ cầu thủ chính thức tham dự World Cup 2026, hội viên chỉ được chọn duy nhất 01 cầu thủ.'
    ],
    conditions: [
      'Mỗi tài khoản chỉ có thể tham gia 01 lần.',
      'Có thể điều chỉnh lựa chọn trước thời gian kết thúc, nếu điều chỉnh nhiều lần hệ thống sẽ lấy lần dự đoán cuối cùng làm chuẩn.',
      'Thời gian kết thúc: 11/06/2026 23:59:59 (GMT +7).',
      'Quy tắc xác định: Chỉ tính số bàn thắng tại các trận chính thức của World Cup (bao gồm hiệp phụ), không bao gồm bàn thắng trong loạt sút luân lưu; nếu có nhiều cầu thủ bằng số bàn thắng, lấy kết quả Vua phá lưới do FIFA công bố chính thức làm chuẩn duy nhất'
    ],
    rewards: [
      'Thời gian phát thưởng 20/07/2026',
      'Dự đoán đúng sẽ nhận được code từ 28 - 28,888 điểm.'
    ]
  },
  // 'Đội nhận nhiều thẻ vàng nhất': {
  //   deadline: '11/06/2026 23:59:59 (GMT+7)',
  //   main: [
  //     'Nội dung dự đoán: Chọn đội nhận  nhiều thẻ vàng nhất của giải đấu.',
  //     'Mỗi tài khoản chỉ có thể tham gia 01 lần cho mỗi hạng mục.'
  //   ],
  //   conditions: [
  //     'Mỗi tài khoản chỉ có thể tham gia 01 lần.',
  //     'Có thể điều chỉnh lựa chọn trước thời gian kết thúc, nếu điều chỉnh nhiều lần hệ thống sẽ lấy lần dự đoán cuối cùng làm chuẩn.',
  //     'Kết quả chính thức căn cứ theo công bố từ FIFA.'
  //   ],
  //   rewards: [
  //     'Thời gian phát thưởng 20/07/2026',
  //     'Dự đoán đúng sẽ nhận được code từ 28 - 28,888 điểm.'
  //   ]
  // },
  'Đội bị loại đầu tiên': {
    deadline: '11/06/2026 23:59:59 (GMT+7)',
    main: [
      'Nội dung dự đoán: Dự đoán đội tuyển bị loại đầu tiên tại World Cup 2026.',
      'Phạm vi dự đoán: Vòng bảng World Cup 2026',
      'Lựa chọn dự đoán: Hiển thị các đội tuyển tham gia vòng bảng làm lựa chọn (theo danh sách hệ thống công bố)'
    ],
    conditions: [
      'Mỗi tài khoản chỉ có thể tham gia 01 lần.',
      'Có thể điều chỉnh lựa chọn trước thời gian kết thúc, nếu điều chỉnh nhiều lần hệ thống sẽ lấy lần dự đoán cuối cùng.',
      'Thời gian kết thúc: 11/06/2026 23:59:59 (GMT +7).',
      'Quy tắc xác định: Đội đầu tiên chính thức bị loại theo kết quả và bảng xếp hạng do FIFA công bố.'
    ],
    rewards: [
      'Thời gian phát thưởng 20/07/2026',
      'Dự đoán đúng sẽ nhận được code từ 28 - 28,888 điểm.'
    ]
  },
  'Đội đầu tiên vào vòng 16': {
    deadline: '11/06/2026 23:59:59 (GMT+7)',
    main: [
      'Nội dung dự đoán: Dự đoán đội tuyển đầu tiên giành quyền vào vòng 16 đội tại World Cup kỳ này',
      'Phạm vi dự đoán: World Cup 2026',
      'Lựa chọn dự đoán: Hiển thị các đội tuyển tham gia vòng bảng làm lựa chọn (theo danh sách hệ thống công bố)'
    ],
    conditions: [
      'Mỗi tài khoản chỉ có thể tham gia 01 lần.',
      'Có thể điều chỉnh lựa chọn trước thời gian kết thúc, nếu điều chỉnh nhiều lần hệ thống sẽ lấy lần dự đoán cuối cùng.',
      'Thời gian kết thúc: 11/06/2026 23:59:59 (GMT +7).',
      'Quy tắc xác định: Căn cứ theo kết quả thi đấu chính thức do FIFA công bố, đội tuyển đầu tiên được xác định chắc chắn có đủ điều kiện vào vòng 32 đội sẽ được xem là đội đầu tiên vào vòng 32',
      'Quy tắc dự phòng: Nếu có từ hai đội trở lên được xác định vào vòng 32 cùng thời điểm, hệ thống sẽ lấy đội có thời gian kết thúc trận đấu sớm hơn làm căn cứ.'
    ],
    rewards: [
      'Thời gian phát thưởng 20/07/2026',
      'Dự đoán đúng sẽ nhận được code từ 28 - 28,888 điểm.'
    ]
  },
  'Đội đầu tiên vào vòng 32': {
    deadline: '11/06/2026 23:59:59 (GMT+7)',
    main: [
      'Nội dung dự đoán: Dự đoán đội tuyển đầu tiên giành quyền vào vòng 32 đội tại World Cup kỳ này',
      'Phạm vi dự đoán: World Cup 2026',
      'Lựa chọn dự đoán: Hiển thị các đội tuyển tham gia vòng bảng làm lựa chọn (theo danh sách hệ thống công bố)'
    ],
    conditions: [
      'Mỗi tài khoản chỉ có thể tham gia 01 lần.',
      'Có thể điều chỉnh lựa chọn trước thời gian kết thúc, nếu điều chỉnh nhiều lần hệ thống sẽ lấy lần dự đoán cuối cùng.',
      'Thời gian kết thúc: 11/06/2026 23:59:59 (GMT +7).',
      'Quy tắc xác định: Căn cứ theo kết quả thi đấu chính thức do FIFA công bố, đội tuyển đầu tiên được xác định chắc chắn có đủ điều kiện vào vòng 32 đội sẽ được xem là đội đầu tiên vào vòng 32',
      'Quy tắc dự phòng: Nếu có từ hai đội trở lên được xác định vào vòng 32 cùng thời điểm, hệ thống sẽ lấy đội có thời gian kết thúc trận đấu sớm hơn làm căn cứ.'
    ],
    rewards: [
      'Thời gian phát thưởng 20/07/2026',
      'Dự đoán đúng sẽ nhận được code từ 28 - 28,888 điểm.'
    ]
  },
  'Đội nhận thẻ đỏ đầu tiên': {
    deadline: '11/06/2026 23:59:59 (GMT+7)',
    main: [
      'Nội dung dự đoán: Dự đoán đội tuyển nhận thẻ đỏ đầu tiên của giải đấu.',
      'Lựa chọn dự đoán: Hệ thống hiển thị danh sách đội tuyển tham dự, hội viên chọn duy nhất 01 đội.'
    ],
    conditions: [
      'Mỗi tài khoản chỉ có thể tham gia 01 lần.',
      'Có thể điều chỉnh lựa chọn trước thời gian kết thúc, nếu điều chỉnh nhiều lần hệ thống sẽ lấy lần dự đoán cuối cùng làm chuẩn.',
      'Thời gian kết thúc: 11/06/2026 23:59:59 (GMT +7).',
      'Quy tắc xác định: Dựa trên đội đầu tiên nhận thẻ đỏ trong trận đấu chính thức theo công bố của FIFA.'
    ],
    rewards: [
      'Thời gian phát thưởng 20/07/2026',
      'Dự đoán đúng sẽ nhận được code từ 28 - 28,888 điểm.'
    ]
  },
  'Cầu thủ xuất sắc nhất': {
    deadline: '11/06/2026 23:59:59 (GMT+7)',
    main: [
      'Nội dung dự đoán: Dự đoán cầu thủ giành danh hiệu Cầu thủ xuất sắc nhất World Cup (Golden Ball).',
      'Lựa chọn dự đoán: Hệ thống hiển thị toàn bộ cầu thủ chính thức tham dự World Cup 2026, hội viên chỉ được chọn duy nhất 01 cầu thủ.'
    ],
    conditions: [
      'Mỗi tài khoản chỉ có thể tham gia 01 lần.',
      'Có thể điều chỉnh lựa chọn trước thời gian kết thúc, nếu điều chỉnh nhiều lần hệ thống sẽ lấy lần dự đoán cuối cùng làm chuẩn.',
      'Thời gian kết thúc: 11/06/2026 23:59:59 (GMT +7).',
      'Quy tắc xác định: Căn cứ vào danh sách Golden Ball do FIFA công bố chính thức.'
    ],
    rewards: [
      'Thời gian phát thưởng 20/07/2026',
      'Dự đoán đúng sẽ nhận được code từ 28 - 28,888 điểm.'
    ]
  },
  'Đội Châu Á Vào Sâu Nhất': {
    deadline: '11/06/2026 23:59:59 (GMT+7)',
    main: [
      'Nội dung dự đoán: Dự đoán đội tuyển châu Á có thành tích tiến sâu nhất tại World Cup kỳ này',
      'Lựa chọn dự đoán: Nền tảng chỉ hiển thị các đội tuyển châu Á chính thức tham dự World Cup kỳ này, người dùng chọn duy nhất 1 đội'
    ],
    conditions: [
      'Mỗi tài khoản chỉ có thể tham gia 01 lần.',
      'Có thể điều chỉnh lựa chọn trước thời gian kết thúc, nếu điều chỉnh nhiều lần hệ thống sẽ lấy lần dự đoán cuối cùng làm chuẩn.',
      'Quy tắc xác định: So sánh theo vòng đấu mà đội tuyển dừng chân cuối cùng; nếu có nhiều đội dừng ở cùng một vòng, thì so sánh điểm số vòng bảng; nếu điểm số vòng bảng vẫn bằng nhau, thì so sánh hiệu số bàn thắng bại vòng bảng'
    ],
    rewards: [
      'Thời gian phát thưởng 20/07/2026',
      'Dự đoán đúng sẽ nhận được code từ 28 - 28,888 điểm.'
    ]
  }
};

const rewardVipColumns = [
  'VIP0 - VIP2',
  'VIP3 - VIP10',
  'VIP11 - VIP15',
  'VIP16 - VIP20',
  'VIP21 - VIP30',
  'VIP31 - VIP50',
  'VIP51 - VIP60'
];

const rewardRows = [
  {
    label: 'Tỉ số mỗi trận đấu',
    values: ['28', '88', '188', '288', '388', '888', '18,888']
  },
  {
    label: 'Đội Châu Á vào sâu nhất',
    values: ['38', '108', '288', '388', '588', '1,888', '18,888']
  },
  {
    label: 'Đội nhận thẻ đỏ đầu tiên',
    values: ['48', '118', '388', '488', '688', '2,888', '18,888']
  },
  {
    label: 'Vua phá lưới',
    values: ['68', '188', '388', '688', '888', '2,888', '28,888']
  },
  {
    label: 'Đội vô địch',
    values: ['68', '188', '388', '688', '888', '2,888', '28,888']
  },
  {
    label: 'Cầu thủ xuất sắc',
    values: ['68', '188', '388', '688', '888', '2,888', '28,888']
  }
];

const SectionTitle = ({ text }) => (
  <div className="relative mx-auto w-full">
    <div className="relative mx-auto flex w-fit items-center justify-center gap-2 bg-[#cfe0d2] px-3 py-2 md:gap-3">
      <div
        className="flex h-[60px] w-[min(384px,86vw)] items-center justify-center bg-no-repeat bg-center bg-contain px-4 text-center text-[20px] font-bold uppercase leading-none text-white md:h-[92px] md:w-[440px] md:text-[30px]"
        style={{ backgroundImage: `url(${bgTitle})` }}
      >
        {text}
      </div>
    </div>
  </div>
);

const ResultRulePrizePanel = ({ activeTabIndex: controlledTabIndex, onTabIndexChange }) => {
  const [localTabIndex, setLocalTabIndex] = useState(7);
  const tabRefs = useRef({});
  const tabScrollRef = useRef(null);
  const rewardTableScrollRef = useRef(null);
  const [canScrollRewardLeft, setCanScrollRewardLeft] = useState(false);
  const [canScrollRewardRight, setCanScrollRewardRight] = useState(false);

  const activeTabIndex =
    typeof controlledTabIndex === 'number' && controlledTabIndex >= 0
      ? controlledTabIndex
      : localTabIndex;

  const activeTab = categoryTabs[activeTabIndex] || categoryTabs[0];

  const setTabIndex = (nextIndex) => {
    if (typeof onTabIndexChange === 'function') {
      onTabIndexChange(nextIndex);
      return;
    }
    setLocalTabIndex(nextIndex);
  };

  const activeRule = useMemo(
    () => ruleContentByTab[activeTab] || ruleContentByTab['Cầu thủ xuất sắc nhất'],
    [activeTab]
  );

  useEffect(() => {
    const scrollEl = tabScrollRef.current;
    const activeTabEl = tabRefs.current[activeTab];
    if (!activeTabEl || !scrollEl) return;

    const nextLeft = activeTabEl.offsetLeft - (scrollEl.clientWidth - activeTabEl.clientWidth) / 2;
    scrollEl.scrollTo({ left: Math.max(0, nextLeft), behavior: 'smooth' });
  }, [activeTab]);

  useEffect(() => {
    const scrollEl = rewardTableScrollRef.current;
    if (!scrollEl) return undefined;

    const updateRewardScrollState = () => {
      const maxScrollLeft = Math.max(0, scrollEl.scrollWidth - scrollEl.clientWidth);
      const currentLeft = scrollEl.scrollLeft;
      setCanScrollRewardLeft(currentLeft > 4);
      setCanScrollRewardRight(currentLeft < maxScrollLeft - 4);
    };

    updateRewardScrollState();
    scrollEl.addEventListener('scroll', updateRewardScrollState, { passive: true });
    window.addEventListener('resize', updateRewardScrollState);

    return () => {
      scrollEl.removeEventListener('scroll', updateRewardScrollState);
      window.removeEventListener('resize', updateRewardScrollState);
    };
  }, []);

  return (
    <div className="mx-auto mt-4 w-full max-w-[1236px] space-y-4 md:mt-5 md:space-y-5">
      <section className="overflow-hidden rounded-[24px] ring-[3px] ring-[#11833c] bg-[#cfe0d2] p-3 md:p-4">
        <SectionTitle text="Thể lệ" />

        <div className="mx-auto mb-3 flex w-full items-center gap-2 md:mb-4 md:max-w-[1120px]">
          <button
            type="button"
            onClick={() => {
              const next = (activeTabIndex - 1 + categoryTabs.length) % categoryTabs.length;
              setTabIndex(next);
            }}
            className="cursor-pointer flex h-8 w-8 shrink-0 items-center justify-center border-none bg-transparent text-[28px] text-[#007524] outline-none ring-0 appearance-none focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 md:h-10 md:w-10 md:text-[32px]"
            aria-label="Tab trước"
          >
            <ChevronLeft size={24} strokeWidth={2.5} />
          </button>

          <div
            ref={tabScrollRef}
            className="scrollbar-hide flex min-w-0 flex-1 items-center justify-start gap-[4px] overflow-x-auto overflow-y-visible px-[2px] pt-[2px] pb-1 md:gap-1"
          >
            {categoryTabs.map((tab) => {
              const isActive = activeTab === tab;

              if (isActive) {
                return (
                  <div
                    key={tab}
                    ref={(el) => {
                      tabRefs.current[tab] = el;
                    }}
                    className="rounded-[8px] bg-gradient-to-b from-[#006719] to-[#2CF65D] p-[1px] md:rounded-[10px] md:p-[1px]"
                  >
                    <button
                      type="button"
                      onClick={() => setTabIndex(categoryTabs.findIndex((item) => item === tab))}
                      className="h-[26px] whitespace-nowrap rounded-[7px] border-none appearance-none bg-gradient-to-b from-[#00CD32] to-[#048724] px-2 text-[13px] font-bold uppercase text-white outline-none ring-0 focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 md:h-[36px] md:rounded-[8px] md:px-4 md:text-[18px]"
                    >
                      {tab}
                    </button>
                  </div>
                );
              }

              return (
                <button
                  key={tab}
                  ref={(el) => {
                    tabRefs.current[tab] = el;
                  }}
                  type="button"
                  onClick={() => setTabIndex(categoryTabs.findIndex((item) => item === tab))}
                  className="h-[26px] whitespace-nowrap rounded-[6px] border border-[#9a9a9a] appearance-none bg-[#AEAEAE] px-2 text-[13px] font-bold uppercase text-white outline-none ring-0 shadow-none focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 md:h-[36px] md:rounded-[8px] md:px-4 md:text-[18px]"
                >
                  {tab}
                </button>
              );
            })}
          </div>

          <button
            type="button"
            onClick={() => {
              const next = (activeTabIndex + 1) % categoryTabs.length;
              setTabIndex(next);
            }}
            className="cursor-pointer flex h-8 w-8 shrink-0 items-center justify-center border-none bg-transparent text-[28px] leading-none text-[#007524] outline-none ring-0 appearance-none focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0 md:h-10 md:w-10 md:text-[32px]"
            aria-label="Tab tiếp theo"
          >
            <ChevronRight size={24} strokeWidth={2.5} />
          </button>
        </div>

        <div className="rounded-[20px] border-[2px] border-[#2e8a50] bg-[#dce8de] p-3 md:p-4">
          <div
            className="mx-auto mb-3 flex min-h-[38px] h-auto w-[min(520px,100%)] items-center justify-center bg-no-repeat bg-center px-3 py-2 text-center text-[13px] font-bold leading-tight text-white md:h-[42px] md:w-fit md:px-10 md:py-0 md:text-[20px] md:leading-none"
            style={{ backgroundImage: `url(${bgCount})`, backgroundSize: '100% 100%' }}
          >
            Bắt đầu: 01/06/2026 - Kết Thúc: {activeRule.deadline}
          </div>

          <div className="space-y-3 text-[14px] leading-relaxed text-[#0e2a16] md:text-[20px]">
            <div>
              <div className="mb-1 inline-block rounded-full bg-gradient-to-b from-[#006719] to-[#2CF65D] p-[1px]">
                <div className="rounded-full bg-gradient-to-b from-[#00CD32] to-[#048724] px-3 py-[2px] text-[15px] md:text-[20px] text-white">
                  Nội Dung
                </div>
              </div>
              <ul className="list-disc pl-5">
                {activeRule.main.map((item, idx) => (
                  <li key={`main-${idx}`}>{item}</li>
                ))}
              </ul>
            </div>

            <div>
              <div className="mb-1 inline-block rounded-full bg-gradient-to-b from-[#006719] to-[#2CF65D] p-[1px]">
                <div className="rounded-full bg-gradient-to-b from-[#00CD32] to-[#048724] px-3 py-[2px] text-[15px] md:text-[20px] text-white">
                  Quy Tắc Tham Gia
                </div>
              </div>
              <ul className="list-disc pl-5">
                {activeRule.conditions.map((item, idx) => (
                  <li key={`condition-${idx}`}>{item}</li>
                ))}
              </ul>
            </div>

            <div>
              <div className="mb-1 inline-block rounded-full bg-gradient-to-b from-[#006719] to-[#2CF65D] p-[1px]">
                <div className="rounded-full bg-gradient-to-b from-[#00CD32] to-[#048724] px-3 py-[2px] text-[15px] md:text-[20px] text-white">
                  Phần Thưởng
                </div>
              </div>
              <ul className="list-disc pl-5">
                {activeRule.rewards.map((item, idx) => (
                  <li key={`condition-${idx}`}>{item}</li>
                ))}
              </ul>
              {/* <p>{activeRule.rewards}</p> */}
            </div>
          </div>
        </div>
      </section>

      <section className="overflow-hidden rounded-[24px] ring-[3px] ring-[#11833c] bg-[#cfe0d2] p-3 md:p-4">
        <SectionTitle text="Phần thưởng" />

        <div className="relative">
          <button
            type="button"
            onClick={() =>
              rewardTableScrollRef.current?.scrollBy({ left: -220, behavior: 'smooth' })
            }
            disabled={!canScrollRewardLeft}
            className={`absolute left-0.5 top-1/2 z-10 -translate-y-1/2 md:hidden border-0 bg-transparent p-0 transition ${
              canScrollRewardLeft
                ? 'cursor-pointer text-[#e11d2e] hover:scale-105'
                : 'cursor-not-allowed text-[#e11d2e]/40'
            }`}
            aria-label="Cuộn bảng sang trái"
          >
            <ChevronLeft size={34} strokeWidth={3} />
          </button>
          <button
            type="button"
            onClick={() =>
              rewardTableScrollRef.current?.scrollBy({ left: 220, behavior: 'smooth' })
            }
            disabled={!canScrollRewardRight}
            className={`absolute right-0.5 top-1/2 z-10 -translate-y-1/2 md:hidden border-0 bg-transparent p-0 transition ${
              canScrollRewardRight
                ? 'cursor-pointer text-[#e11d2e] hover:scale-105'
                : 'cursor-not-allowed text-[#e11d2e]/40'
            }`}
            aria-label="Cuộn bảng sang phải"
          >
            <ChevronRight size={34} strokeWidth={3} />
          </button>
          <div
            ref={rewardTableScrollRef}
            className="overflow-x-auto rounded-[20px] [scrollbar-width:thin] md:[scrollbar-width:auto]"
          >
            <table className="w-full min-w-[920px] ring-separate ring-spacing-0 text-center text-[11px] text-[#0f6b2c] md:text-[12px]">
              <thead>
                <tr className="bg-[#006a1f] text-[#FED304]">
                  <th
                    className="ring-r-[1.5px] ring-b-[1.5px] ring-[#8abc97] px-2 py-2 text-[14px] font-bold uppercase align-middle md:text-[20px]"
                    rowSpan={2}
                  >
                    HẠNG MỤC
                  </th>
                  <th
                    className="ring-b-[1.5px] ring-[#8abc97] px-2 py-2 text-[14px] font-bold uppercase md:text-[20px]"
                    colSpan={rewardVipColumns.length}
                  >
                    ĐIỂM
                  </th>
                  <th
                    className="ring-l-[1.5px] ring-b-[1.5px] ring-[#8abc97] px-2 py-2 text-[14px] font-bold uppercase align-middle md:text-[20px]"
                    rowSpan={2}
                  >
                    Vòng cược
                  </th>
                </tr>
                <tr className="bg-[#007625] text-[#FED304] text-[11px] md:text-[16px] font-semibold uppercase">
                  {rewardVipColumns.map((col, idx) => (
                    <th
                      key={col}
                      className={`ring-b-[1.5px] ring-[#8abc97] px-2 py-[6px] ${
                        idx < rewardVipColumns.length - 1 ? 'ring-r-[1.5px]' : ''
                      }`}
                    >
                      {col}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rewardRows.map((row, rowIdx) => (
                  <tr key={row.label} className="bg-[#dce3df]">
                    <td className="ring-r-[1.5px] ring-b-[1.5px] ring-[#8abc97] px-2 py-[6px] text-center md:text-[18px]">
                      {row.label}
                    </td>
                    {row.values.map((value, idx) => (
                      <td
                        key={`${row.label}-${idx}`}
                        className={`ring-b-[1.5px] ring-[#8abc97] px-2 py-[6px] md:text-[17px] ${
                          idx < row.values.length - 1 ? 'ring-r-[1.5px]' : ''
                        }`}
                      >
                        {value}
                      </td>
                    ))}
                    {rowIdx === 0 ? (
                      <td
                        className="ring-l-[1.5px] ring-b-[1.5px] ring-[#8abc97] px-2 py-[6px] align-middle text-[12px] font-semibold md:text-[17px]"
                        rowSpan={rewardRows.length}
                      >
                        1 vòng
                      </td>
                    ) : null}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="overflow-hidden rounded-[24px] ring-[3px] ring-[#11833c] bg-[#cfe0d2] p-3 md:p-4">
        <SectionTitle text="Điều kiện khuyến mãi" />

        <div className="space-y-3 text-[13px] leading-relaxed text-[#0f6b2c] md:space-y-4 md:text-[18px]">
          <p>
            Sau khi có kết quả chính thức, hệ thống sẽ tự động kiểm tra và phát thưởng vào tài khoản
            hội viên trong vòng 24 giờ. Thành viên đăng nhập tài khoản bấm vào【Nhận thưởng】Bấm
            chọn【nhận】để nhận thưởng.
          </p>
          <p>
            Áp dụng cho hội viên hợp lệ có tổng nạp từ ngày hôm trước đến thời điểm dự đoán ≥ 300
            điểm trước khi dự đoán.
          </p>
          <p>
            Mỗi một tài khoản, mỗi một IP, thiết bị đăng nhập, thẻ ngân hàng, Email và SĐT chỉ được
            dự đoán 1 lần/1 trận đấu. Dự đoán hợp lệ là dự đoán được gửi đúng thời gian quy định.
          </p>
          <p>
            Thành viên lạm dụng, vi phạm quy định công ty sẽ không được tham gia khuyến mãi này.
          </p>
          <p>
            QQ88 bảo lưu quyền thay đổi, dừng hoặc hủy bỏ chương trình khuyến mãi này bất cứ lúc
            nào.
          </p>
        </div>
      </section>
    </div>
  );
};

export default ResultRulePrizePanel;
